<div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center" style="margin: 50px 0;">
  <div class="step" *ngFor="let step of steps; let i = index"
    [ngClass]="{'line' : i < steps.length - 1 && steps.length == 3, 'line2': i < steps.length - 1 && steps.length == 4, 'line3' : i < steps.length - 1 && steps.length == 2}">
    <div class="step-icon" [ngClass]="{'active' : step.active, 'checked' : step.checked}">
      <p *ngIf="!step.checked">{{i + 1}}</p>
      <i *ngIf="step.checked" class="fas fa-check"></i>
    </div>
    <div [ngClass]="{'active' : step.active}">{{step.name}}</div>
  </div>
</div>